module.exports = __webpack_public_path__ + "img/pipelines.00e63038.webp";